import type { PlanId } from "../../api/organizations";

export const PAGE_SIZE = 20;

export const statusVariant: Record<string, string> = {
  trialing: "info",
  active: "success",
  past_due: "warning",
  canceled: "secondary",
  unpaid: "danger",
  incomplete: "warning",
  incomplete_expired: "danger",
  paused: "secondary",
  pending_ves: "warning",
  ves_rejected: "danger",
};

export const PLAN_IDS: PlanId[] = ["micro", "standard", "professional", "enterprise"];
export const PLAN_IDS_WITH_CUSTOM: PlanId[] = [...PLAN_IDS, "custom"];

export const SUBSCRIPTION_STATUSES = [
  "trialing",
  "active",
  "past_due",
  "canceled",
  "unpaid",
  "incomplete",
  "incomplete_expired",
  "paused",
  "pending_ves",
  "ves_rejected",
] as const;
